import React, { useContext } from "react";
import { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';
import { useCallback } from "react";
import {
    getCompaniesForAnalytics,
    makeCompanyPremiumByUUID,
    getPlusAppFilterUsers,
    getCompanyNotes,
    saveCompanyNote,
    updateCompanyNote,
    makeCompanyFreemium
} from "../../services/private/company.service";
import { createDatewithTime } from "../../helpers/date"
import EditCompanyModal from "../../components/Modals/EditCompanyModal";
import { useHistory } from "react-router";
import UserLimitExeedModal from "../../components/Modals/userLimitExeedModal";
import {
    OverlayTrigger,
    Tooltip
} from 'react-bootstrap';
import Consumer from '../../helpers/context';
import { isNumber } from "../../helpers/helpers";
import StatsCard from "./StatsCard";
import TooltipText from "../../components/Tooltip";
import LeadsFooterBar from "../LeadsManager/LeadsFooterBar";
import AddRemarksModal from "./Modal/AddRemarksModal";
import MakeCompanyFreemium from "./Modal/MakeCompanyFreemium";

const USER_UUID = localStorage.getItem('user');

export default function CompanyAnalytics({
    companyDetails,
    getCompanyData,
    companyStats,
    handleFilter,
    selectedStats,
    showingResults,
    setShowingResults,
    currentPage,
    setCurrentPage,
    leadsCount,
    maxPage,
    companyStartIndex
}) {

    const [selectedCompany, setSelectedCompany] = useState(null);
    const [showCompanyModal, setShowCompanyModal] = useState(false);
    const [showRemarksModal, setShowRemarksModal] = useState(false);
    const [remarksList, setRemarksList] = useState([]);
    const [selectedItem, setSelectedItem] = useState({});
    const [showChangePlanModal, setShowChangePlanModal] = useState(false)

    // const [roles, setRoles] = useState([]);
    // const [users, setusers] = useState();
    // const [reAssignUser, setReAssignUser] = useState();
    const [error, setError] = useState(false);


    let { allowedPermissions, isRolesModule } = useContext(Consumer);

    const ROLE_NAME = localStorage.getItem('role');
    const history = useHistory();

    const handlePremium = (uuid) => {
        makeCompanyPremiumByUUID(uuid).then(res => {
            if (res.status === 200) {
                toast.success(res.data.message)
                getCompanyData();

            }
        }).catch((e) => {
            toast.error(e.response.data.message);
        });
    }

    const getClassName = (type) => {
        switch (type) {
            case 'freemium':
                return 'cold-btn'
            case 'premium':
                return 'hot-btn'
            case 'free':
                return 'dead-btn'
        }
    }

    const getRemarks = async (uuid) => {
        const res = await getCompanyNotes(uuid);
        if (res.data.status === 200) {
            console.log(res.data.data, 'remakrs')
            setRemarksList(res.data.data)
            setShowRemarksModal(true);
        }
    }
    const handleChangeRemarks = async (remarks) => {
        // const res = await updateRemarksByUUID(selectedItem.uuid, { remarks });
        console.log(remarks, 'remark')
        const res = await saveCompanyNote(selectedItem.uuid, { note: remarks });
        if (res.data.status === 200) {
            toast.success(res.data.message);
            setSelectedItem({});
            setShowRemarksModal(false);
            getCompanyData();
        }
    }

    const handleUpdateRemark = async (selectedRemark) => {
        const res = await updateCompanyNote(selectedRemark.uuid, { note: selectedRemark.note })
        if (res.data.status === 200) {
            toast.success(res.data.message);
            setSelectedItem({});
            setShowRemarksModal(false);
            setRemarksList([])
            getCompanyData();
        }
    }

    const handleChangeCompany = async (plan) => {
        const res = await makeCompanyFreemium(selectedItem.uuid, { plan_id: plan })
        if (res.data.status === 200) {
            setShowChangePlanModal(false);
            toast.success(res.data.message);
            getCompanyData();
        }
    }

    return (
        <>
            {showCompanyModal ?
                <EditCompanyModal
                    show={showCompanyModal}
                    setShow={setShowCompanyModal}
                    selectedCompany={selectedCompany}
                    getCompanyData={getCompanyData}
                />
                : null}

            <div className="users w-100 h-full flex flex-col">
                <div className="grid grid-cols-4 !gap-4 !mb-4">

                    <StatsCard statsCount={companyStats.total} statsType={'Total'} handleFilter={handleFilter} selectedStats={selectedStats} />
                    <StatsCard statsCount={companyStats.not_paid} statsType={'Free'} handleFilter={() => { }} selectedStats={selectedStats} />
                    <StatsCard statsCount={companyStats.premium} statsType={'Premium'} handleFilter={handleFilter} selectedStats={selectedStats} />
                    <StatsCard statsCount={companyStats.freemium} statsType={'Freemium'} handleFilter={handleFilter} selectedStats={selectedStats} />

                </div>
                <div className="urer-table pr-0">
                    <div className="def-table !h-[60vh] pr-0">
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th>S.No.</th>
                                    <th>Company Name</th>
                                    <th>Name</th>
                                    <th>Mobile</th>
                                    <th>Email</th>
                                    <th>Signup Date</th>
                                    <th>Operational City</th>
                                    <th> Subscription Type</th>
                                    <th>Subscription Date</th>
                                    <th>Remarks</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {companyDetails && companyDetails?.length > 0 ? companyDetails.map((company, index) => {
                                    const { uuid, name, owner_name, owner_mobile, subscription_type, owner_email, is_subscribed, subscription_expiry, created_on, subscription_date, operational_cities, remarks, latest_note } = company;
                                    return (
                                        <tr key={index}>
                                            <td>{index + companyStartIndex}</td>
                                            <td className="text-capitalize">
                                                {name?.length > 20 ?
                                                    <OverlayTrigger
                                                        placement="bottom"
                                                        overlay={
                                                            <Tooltip id="button-tooltip" >
                                                                <div className='info-msg'>
                                                                    <p className='text-capitalize'>{name}</p>
                                                                </div>
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span className='text-capitalize three-dots'>{name}</span>
                                                    </OverlayTrigger>
                                                    :
                                                    <span className='text-capitalize'>{name || '-'}</span>
                                                }
                                            </td>
                                            <td>
                                                {owner_email?.length > 20 ?
                                                    <OverlayTrigger
                                                        placement="bottom"
                                                        overlay={
                                                            <Tooltip id="button-tooltip" >
                                                                <div className='info-msg'>
                                                                    <p className=''>{owner_name}</p>
                                                                </div>
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span className='three-dots'>{owner_name}</span>
                                                    </OverlayTrigger>
                                                    :
                                                    <span className=''>{owner_name}</span>
                                                }
                                            </td>
                                            <td>{owner_mobile ? owner_mobile : "-"}</td>

                                            <td>{owner_email ? owner_email : "-"}</td>
                                            <td>{createDatewithTime(created_on)}</td>
                                            <td className="!w-[200px]">
                                                {operational_cities?.length > 0 ?

                                                    <TooltipText title={operational_cities?.join(', ')}>
                                                        <div className="w-[200px] truncate">
                                                            {operational_cities?.join(', ')}
                                                        </div>
                                                    </TooltipText>
                                                    : '-'
                                                }
                                            </td>
                                            <td >
                                                <button className={`${getClassName(subscription_type ? subscription_type.toLowerCase() : 'free')} w-20 capitalize`}>
                                                    {subscription_type ? subscription_type : 'Free'}
                                                </button>
                                            </td>
                                            <td>{subscription_date ? createDatewithTime(subscription_date) : '-'}</td>
                                            <td>
                                                {
                                                    latest_note && <TooltipText title={'Edit/Show Remarks'}>
                                                        <div
                                                            className='truncate w-[200px] cursor-pointer'
                                                            onClick={() => {
                                                                setSelectedItem(company)
                                                                getRemarks(uuid)
                                                            }}
                                                        >{latest_note || remarks}</div>
                                                    </TooltipText>
                                                }
                                                {
                                                    !latest_note && <span className="border rounded-lg flex cursor-pointer w-20 hover:bg-black200 items-center justify-center" onClick={() => {
                                                        setSelectedItem(company)
                                                        getRemarks(uuid)
                                                        // setShowRemarksModal(true);
                                                    }}>
                                                        + Add
                                                    </span>
                                                }
                                            </td>
                                            <td className="dropdown view-more ">
                                                {(allowedPermissions?.includes('plus_app_manage_subscription') || allowedPermissions?.includes('plus_app_manage_users')) &&
                                                    <button
                                                        className="bg-tr border-0"
                                                        type="button"
                                                        id="dropdownMenuButton"
                                                        data-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M12 17C10.8954 17 10 17.8954 10 19C10 20.1046 10.8954 21 12 21C13.1046 21 14 20.1046 14 19C14 17.8954 13.1046 17 12 17Z"
                                                                fill="#B5B5BE"
                                                            />
                                                            <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
                                                                fill="#B5B5BE"
                                                            />
                                                            <path
                                                                fillRule="evenodd"
                                                                // clipRule="evenodd"
                                                                d="M12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3Z"
                                                                fill="#B5B5BE"
                                                            />
                                                        </svg>
                                                    </button>}
                                                <div
                                                    className="dropdown-menu dropdown-menu-right w-auto"
                                                    aria-labelledby="dropdownMenuButton"
                                                    onClick={() => setSelectedCompany({ uuid, name, owner_name, owner_mobile, owner_email, is_subscribed, subscription_expiry })}
                                                >

                                                    {allowedPermissions?.includes('plus_app_manage_users') && <a
                                                        className="dropdown-item"
                                                        data-toggle="modal"
                                                        data-target="#exampleModal"
                                                        onClick={
                                                            () => {
                                                                setShowCompanyModal(true)
                                                            }
                                                        }
                                                    >
                                                        Edit Company
                                                    </a>}
                                                    {allowedPermissions?.includes('plus_app_manage_subscription') && (subscription_type?.toLowerCase() === 'freemium' || !subscription_type) && <a
                                                        className="dropdown-item"
                                                        data-toggle="modal"
                                                        data-target="#exampleModal"
                                                        onClick={() => handlePremium(uuid)}
                                                    >
                                                        Make Company Premium
                                                    </a>}
                                                    {allowedPermissions?.includes('plus_app_manage_subscription') && !subscription_type && <a
                                                        className="dropdown-item"
                                                        data-toggle="modal"
                                                        data-target="#exampleModal"
                                                        onClick={() => {
                                                            setSelectedItem(company)
                                                            setShowChangePlanModal(true)
                                                        }}
                                                    >
                                                        Make Company Freemium
                                                    </a>}
                                                    {/* <Link
                                                        className="dropdown-item"
                                                        data-toggle="modal"
                                                        data-target="#exampleModal"
                                                        to={`/plus-app/refer-earn/${uuid}`}
                                                    >
                                                        View Refer & earn
                                                    </Link> */}

                                                </div>

                                            </td>
                                        </tr>
                                    )
                                }) : null}
                            </tbody>
                        </table>
                    </div>
                    <LeadsFooterBar
                        showingResults={showingResults}
                        setShowingResults={setShowingResults}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        maxPage={maxPage}
                        leadsCount={leadsCount}
                        classname='!relative !basis-0 !w-full'
                    />
                </div>
                {
                    showRemarksModal && <AddRemarksModal
                        show={showRemarksModal}
                        closeModal={() => {
                            setSelectedItem({})
                            setShowRemarksModal(false)
                            setRemarksList([]);
                        }}
                        item={selectedItem}
                        handleSubmit={handleChangeRemarks}
                        remarksList={remarksList}
                        setRemarksList={setRemarksList}
                        handleUpdateRemark={handleUpdateRemark}
                    />
                }

                {showChangePlanModal && selectedItem.uuid &&
                    <MakeCompanyFreemium
                        show={showChangePlanModal}
                        closeModal={() => setShowChangePlanModal(false)}
                        handleSubmit={handleChangeCompany}
                    />}
            </div>

        </>
    )
}
